import { isRecoverableWarning, windowOnErrorHandler } from '@shared/utils/appUtils';
import { renderErrorModal } from '@shared/utils/errorHandlerUtil';
import { handleInterruptedHydration } from './recoverableHydrationError';
export const onError = (window, store)=>{
    const eventListener = (msg, file, line, col, error)=>{
        if (handleInterruptedHydration(msg)) {
            return;
        }
        windowOnErrorHandler({
            msg,
            file,
            line,
            col,
            error
        });
        if ((file === null || file === void 0 ? void 0 : file.indexOf(window.location.origin)) > -1 && !isRecoverableWarning(msg)) {
            renderErrorModal(store);
        }
    };
    window.onerror = eventListener;
};
